import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';
import { SharedFeatureComponentsModule } from '@digilize/shared/feature/components/src';
import { ApiInterceptor } from '@digilize/shared/feature/modules/auth/src';
import { GlobalErrorHandler, GlobalErrorHandlerWithLog } from '@digilize/shared/feature/modules/error-handling';
import { CustomTitleWithSuffixStrategyService } from '@digilize/shared/feature/modules/i18n/src';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material';
import { APP_CONFIG, ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

import { appConfig } from '../environments/app.config';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslocoRootModule } from './transloco-root.module';
import { MainModule } from './views/main.module';
import { NGX_MAT_DATE_FORMATS, NgxMatDateFormats } from '@angular-material-components/datetime-picker';

const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY HH:mm',
  },
  display: {
    dateInput: 'DD/MM/YYYY HH:mm',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
registerLocaleData(localeNl, 'nl-NL');
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    InlineSVGModule.forRoot({ baseUrl: '/assets' }),
    LazyLoadImageModule,
    SharedUiMaterialModule,
    AppRoutingModule,
    MainModule,
    RecaptchaV3Module,
    SharedFeatureComponentsModule,
    SharedUiComponentsModule,
    TranslocoRootModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: environment.production ? GlobalErrorHandlerWithLog : GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB',
    },
    {
      provide: LOCALE_ID,
      useValue: 'nl-NL',
    },
    {
      provide: ENV_CONFIG,
      useValue: environment,
    },
    {
      provide: APP_CONFIG,
      useValue: appConfig,
    },
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },

    { provide: TitleStrategy, useClass: CustomTitleWithSuffixStrategyService },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
